import { isSet } from "../utils/isSet";
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll'
import ClassNames from 'embla-carousel-class-names';
import { setupLazyLoadImage } from './carouselLazyLoad';

function initCarousels(){
    function initLogoRowCarousel(){
        const carouselNodes = document.querySelectorAll('.block--logo-row .embla--js');
        if(!isSet(carouselNodes)) return;

        carouselNodes.forEach((carouselNode) => {
            const viewportNode = carouselNode.querySelector('.embla__viewport');
            if(!isSet(viewportNode)) return;

            const slideNodes = viewportNode.querySelectorAll('.embla__slide');
            if(!isSet(slideNodes) || slideNodes.length === 0) return;

            const carouselOptions = {
                align: 'center',
                loop: true,
                watchDrag: false,
                watchFocus: false
            }

            const carouselApi = EmblaCarousel(
                viewportNode,
                carouselOptions,
                [
                    AutoScroll(
                        {
                            speed: 1
                        }
                    ),
                    ClassNames()
                ]
            );

            const loadImagesInView = setupLazyLoadImage(carouselApi);

            const toggleActiveWhenScrollable = (carouselApi, carouselNode) => {
                const isScrollable = carouselApi.internalEngine().scrollSnaps.length > 1;
                if(isScrollable){
                    carouselNode.classList.add('is-active');
                    carouselNode.classList.remove('is-disabled');
                } else{
                    carouselNode.classList.add('is-disabled');
                    carouselNode.classList.remove('is-active');
                }
            }

            const toggleActive = () => {
                toggleActiveWhenScrollable(carouselApi, carouselNode);
            };

            carouselApi
                .on('init', loadImagesInView)
                .on('init', toggleActive)
                .on('reInit', loadImagesInView)
                .on('slidesInView', loadImagesInView)
                .on('resize', toggleActive)
        });
    }
    initLogoRowCarousel();


    function initImageCardCarousel(){
        const carouselNodes = document.querySelectorAll('.block--card-carousel.embla--js');
        if(!isSet(carouselNodes)) return;

        carouselNodes.forEach((carouselNode) => {
            const viewportNode = carouselNode.querySelector('.embla__viewport');
            if(!isSet(viewportNode)) return;

            const slideNodes = viewportNode.querySelectorAll('.embla__slide');
            if(!isSet(slideNodes) || slideNodes.length === 0) return;

            const carouselOptions = {
                align: 'center',
                loop: true,
                dragFree: true,
                watchFocus: false
            }

            const carouselApi = EmblaCarousel(
                viewportNode,
                carouselOptions,
                [
                    ClassNames()
                ]
            );

            const loadImagesInView = setupLazyLoadImage(carouselApi);

            const toggleActiveWhenScrollable = (carouselApi, carouselNode) => {
                const isScrollable = carouselApi.internalEngine().scrollSnaps.length > 1;
                if(isScrollable){
                    carouselNode.classList.add('is-active');
                    carouselNode.classList.remove('is-disabled');
                } else{
                    carouselNode.classList.add('is-disabled');
                    carouselNode.classList.remove('is-active');
                }
            }

            const toggleActive = () => {
                toggleActiveWhenScrollable(carouselApi, carouselNode);
            };

            carouselApi
                .on('init', loadImagesInView)
                .on('init', toggleActive)
                .on('reInit', loadImagesInView)
                .on('slidesInView', loadImagesInView)
                .on('resize', toggleActive)
        });
    }
    initImageCardCarousel();
}
export { initCarousels };
